import { useEffect } from 'react';
import { isAndroid, isIOS, isMacOs, isSafari } from 'react-device-detect';

import { TEACHERS_HOME_URL, TEACHER_ASSIGNMENTS_V2_URL } from 'config/urls';

const HOME_PAGE_ENABLED = process.env.REACT_APP_HOME_PAGE_ENABLED === 'true';

const MobileApp = ({ history }) => {
  useEffect(() => {
    if (isAndroid) {
      window.location.replace(
        'https://play.google.com/store/apps/details?id=app.edlight'
      );
    } else if (isIOS || isSafari || isMacOs) {
      window.location.replace(
        'https://apps.apple.com/bg/app/edlight/id1570328651'
      );
    } else {
      if (HOME_PAGE_ENABLED) {
        window.location.replace(TEACHERS_HOME_URL);
      } else {
        window.location.replace(TEACHER_ASSIGNMENTS_V2_URL);
      }
    }
  }, []);

  return null;
};

export default MobileApp;
